import { useSnackListStore } from "@eventr/common-storybook";
import { routes } from "routing";
import { isIosToastAvailable } from "../../state/overlayState/native-toast";
import { addToSnackQueue } from "../../state/overlayState/overlayContext";
import { RocketSnack } from "./Components/RocketSnack";
import { getChatNameSnapshot } from "./hooks/useGetChatName";
import { cacheRoomType, showNativeRocketToast } from "./native-rocket-toast";

export function createRocketSnack(messageContents: any) {
  if (!messageContents) return;

  const rid = messageContents?.payload?.rid;
  const type = messageContents?.payload?.type;
  const title = messageContents?.title;
  const text = messageContents?.text;

  if (isIosToastAvailable()) {
    if (!rid) return;
    // Suppresses toasts for the room already being viewed or the chat list, same as RocketSnack.tsx.
    if (window.location.pathname.includes(rid) || window.location.pathname.includes(routes.chat.list.path)) {
      return;
    }
    cacheRoomType(rid, type);
    const chatName = getChatNameSnapshot(rid);
    void showNativeRocketToast(rid, chatName ?? title, text);
    return;
  }

  const snackListStore = useSnackListStore.getState();
  snackListStore.removeSnackFromList(rid);
  addToSnackQueue(<RocketSnack messageContents={messageContents} uId={rid} />, rid);
}
